export function warrantyCoverage(warranty) {
  if (!warranty?.id) return { frame: false, lens: false }
  const appliesTo = String(warranty.applies_to || '').toLowerCase()
  return {
    frame: appliesTo === 'frame' || appliesTo === 'both',
    lens: appliesTo === 'lens' || appliesTo === 'both',
  }
}
